/* localStorage that never throws: it can be missing or blocked (private
   windows, cleared site data), and the site must work without it. */
export function readJSON(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key)
    return raw == null ? fallback : JSON.parse(raw)
  } catch (e) {
    return fallback
  }
}

export function writeJSON(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    // storage full or blocked: keep working in memory
  }
}

export function removeKey(key) {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    // ignore
  }
}

export const KEYS = {
  myTopics: 'instapres.myTopics',
  followedSources: 'instapres.followedSources',
  recentSearches: 'instapres.recentSearches',
  migratedProfile: 'instapres.migratedProfile',
  // Anonymous profile (pres: POST /api/me) the crossword's results belong to.
  profileToken: 'instapres.profileToken',
  // The cookie banner's choice: 'all' | 'necessary' (analytics spec 3.6).
  consent: 'instapres.consent',
  analyticsSession: 'instapres.analyticsSession',
  // Ads (ads spec 3.2): the rollout id, and the last GET /v1/config "ads".
  installId: 'instapres.installId',
  adsConfig: 'instapres.adsConfig',
}
